import { render } from "./RegistrationCompensationTableCellComponent.vue?vue&type=template&id=5c34ed70&scoped=true"
import script from "./RegistrationCompensationTableCellComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationCompensationTableCellComponent.vue?vue&type=script&lang=js"

import "./RegistrationCompensationTableCellComponent.vue?vue&type=style&index=0&id=5c34ed70&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c34ed70"]])

export default __exports__